import gql from 'graphql-tag';

export const AgreementByContractQuery = gql`
  query agreementByContract($where: AgreementByContractWhereInput!) {
    agreementByContract(where: $where) {
      id
      # contract
      typ
      prijmeni
      jmeno
      email
      telefon
      mesto
      psc
      source
      ip_address
      odvolany
      expire_time
      vytv_time
    }
  }
`;

export const AgreementByOnlineFormQuery = gql`
  query agreementByOnlineForm($where: AgreementByOnlineFormWhereInput!) {
    agreementByOnlineForm(where: $where) {
      id
      # contract
      typ
      prijmeni
      jmeno
      email
      telefon
      mesto
      psc
      source
      ip_address
      odvolany
      expire_time
      vytv_time
    }
  }
`;

export const AgreementCreateMutation = gql`
  mutation agreementCreate($data: AgreementCreateInput!) {
    agreementCreate(data: $data) {
      id
    }
  }
`;
